import React from "react";
import styles from "../../assets/preview.module.scss";
import bannerService from "../../redux/services/banner.service";
import { format } from "date-fns";
import { Card, CardBody, Col, Row } from "reactstrap";
import { useSelector } from "react-redux";
import IconContainer from "../Common/IconContainer";
import * as Ionicons from "react-icons/io";
import PageContainer from "../Layout/PageContainer";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
const EditIcon = Ionicons["IoIosCreate"];
const DeleteIcon = Ionicons["IoIosTrash"];
const RestoreIcon = Ionicons["IoIosRefresh"];
function OfferBanner({ currentUser }) {
  const navigate = useNavigate();
  const [banners, setBanners] = React.useState([]);
  const [status, setStatus] = React.useState("");
  const currentModuleId = 18;
  const { permissionMap } = useSelector((state) => state.auth);
  const { permission: permissionData } = permissionMap;
  // Find Out Users Permission
  const permission = permissionData?.find(
    (perm) => perm.moduleId === currentModuleId
  );
  React.useEffect(() => {
    async function fetchBannerList() {
      try {
        const res = await bannerService.getOfferBannersList({ status });
        setBanners(res.data.data);
      } catch (error) {
        console.error(error);
      }
    }
    fetchBannerList();
  }, [status]);

  async function handleDelete(e, publicId) {
    try {
      const res = await bannerService.deleteOfferBanner(publicId);
      if (res.data.data) {
        toast.success("Banner deleted successfully");
        const res = await bannerService.getOfferBannersList({ status });
        setBanners(res.data.data);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  }
  const handleViewClick = (row) => navigate(`/offer-banner/${row.publicId}`);
  const columns = React.useMemo(() => {
    const commonColumns = [
      {
        name: "Banner Type",
        selector: (row) => {
          return row?.ad?.adType || "N/A";
        },
        headerStyle: {
          textAlign: "center",
        },
      },
      {
        name: "Banner Image",
        selector: (row) => {
          let imageUrl = row?.ad?.adImage[0]?.imageUrl;
          if (!imageUrl) {
            imageUrl = row.bannerImages[0];
          }
          return (
            <div
              className={styles.previewContainer}
              style={{
                position: "relative",
                display: "inline-block",
              }}
            >
              <img
                width={100}
                src={imageUrl || "default.jpg"}
                alt="preview"
                // onError={(e) => {
                //   e.target.onerror = null;
                //   e.target.src =
                //     `${process.env.REACT_APP_PROFILE_IMAGE_URL}` + `user.png`;
                // }}
              />
            </div>
          );
        },
        headerStyle: {
          textAlign: "center",
        },
      },
      {
        name: "Banner Image 2",
        selector: (row) => {
          let imageUrl = row?.ad?.tradeItem?.imageUrl;
          if (!imageUrl) {
            imageUrl = row?.ad?.adImage[1]?.imageUrl;
          }
          if (!imageUrl) {
            imageUrl = row.bannerImages[1];
          }
          return (
            <div
              className={styles.previewContainer}
              style={{
                position: "relative",
                display: "inline-block",
              }}
            >
              <img
                width={100}
                src={imageUrl || "default.jpg"}
                alt="preview"
                // onError={(e) => {
                //   e.target.onerror = null;
                //   e.target.src =
                //     `${process.env.REACT_APP_PROFILE_IMAGE_URL}` + `user.png`;
                // }}
              />
            </div>
          );
        },
        headerStyle: {
          textAlign: "center",
        },
      },
      {
        name: "Offer Main Text",
        selector: (row) => `${row?.offerMainTitle}`,
        width: "230px",
        headerStyle: {
          textAlign: "center",
        },
      },
      {
        name: "Offer Description",
        selector: (row) => `${row?.offerMainDescription}`,
        width: "230px",
        headerStyle: {
          textAlign: "center",
        },
      },
      {
        name: "Offer Season Text",
        selector: (row) => `${row?.offerSeasonText}`,
        width: "230px",
        headerStyle: {
          textAlign: "center",
        },
      },
      {
        name: "Voucher",
        selector: (row) => `${row?.voucher}`,
        width: "230px",
        headerStyle: {
          textAlign: "center",
        },
      },
      {
        name: "Banner Type",
        selector: (row) => `${row?.bannerType}`,
        sortable: true,
        width: "230px",
        headerStyle: {
          textAlign: "center",
        },
      },
      {
        name: "Created At",
        selector: (row) => format(new Date(row?.createdAt), "PPpp"),
        sortable: true,
        width: "230px",
        headerStyle: {
          textAlign: "center",
        },
      },
      {
        name: "Updated At",
        selector: (row) => format(new Date(row?.updatedAt), "PPpp"),
        sortable: true,
        width: "230px",
        headerStyle: {
          textAlign: "center",
        },
      },
    ];

    const renderActionCell = (row) => {
      const isDeleted = row?.deletedAt && row?.deletedAt !== null;
      if (isDeleted) {
        return permission?.delete ? (
          <IconContainer
            id={"restore-icon"}
            Icon={RestoreIcon}
            // handleOnClick={(e) => handleDelete(e, row?.publicId, "restore")}
            text={"Restore"}
            iconColor={"#3ac47d"}
          />
        ) : null;
      }

      return (
        <>
          {/* {permission?.update ? (
            <IconContainer
              id={"edit-icon"}
              Icon={EditIcon}
              handleOnClick={() => handleViewClick(row)}
              text="Edit"
            />
          ) : null} */}
          {permission?.delete ? (
            <IconContainer
              id={"delete-icon"}
              Icon={DeleteIcon}
              handleOnClick={(e) => handleDelete(e, row?.publicId, "delete")}
              text={"Delete"}
              iconColor={"#d92550"}
            />
          ) : null}
        </>
      );
    };

    if (permission?.delete === 0 && permission?.update === 0) {
      return commonColumns;
    }

    return [
      ...commonColumns,
      {
        name: "Actions",
        button: true,
        minWidth: "150px",
        headerStyle: { textAlign: "center" },
        cell: renderActionCell,
      },
    ];
  }, [permission]);

  return (
    <React.Fragment>
      <PageContainer
        pageTitleIcon="pe-7s-photo icon-gradient bg-plum-plate"
        pageHeading={"Offer Banners List"}
        pageSubTitle={"List of all banners in the system"}
      >
        <Row>
          <Col>
            <Card className="main-card mb-3">
              <CardBody>
                <DataTable
                  columns={columns}
                  data={banners}
                  pagination
                  paginationServer
                  paginationTotalRows={10}
                  //   paginationDefaultPage={currentPage}
                  //   onChangeRowsPerPage={handlePerRowsChange}
                  //   onChangePage={handlePageChange}
                  subHeader
                  //   subHeaderComponent={subHeaderComponent}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </PageContainer>
    </React.Fragment>
  );
}

export default OfferBanner;
